import React from 'react';
import ShareEntity from 'components/ShareEntity/Loadable';
import { useTranslation } from 'react-i18next';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

export function Body() {
  const { t } = useTranslation(['cahierJournal']);
  const { school } = useSchoolSchoolyear();
  return (
    <ShareEntity
      description={t('cahierJournal:shareCJDescription')}
      entityId={school.id}
      entityType="cahierJournal"
      entityUrl="cahier-journal"
    />
  );
}
